import React from 'react';
import { Modal, Typography, Button, List, ListItem } from '@hpstellar/core/visId';
import './hard-bundle-modal.less';

const HardBundleModal = ({ isOpen, onClose = () => {}, bundleComponents = [], bundleSpecs = [] }) => {
    if (!bundleComponents || !bundleComponents.length) {
        return null;
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            bundleSpecs={bundleSpecs}
            title="Bundle items"
            horizontalAlignment="right"
            animationType="slide-in-right"
            size="sm"
            className="hard-bundle-sidebar-modal"
            modalClassName="hb-modal"
            headerProps={{ className: 'hb-modal-header' }}
        >
            <div className="hard-bundle-sidebar-content bundle-sidebar-body">
                {bundleComponents.map((component, idx) => {
                    const { name, sku, quantity, thumbnail, keyPoints } = component;
                    const hasName = typeof name === 'string' && name.trim().length > 0;
                    const hasQuantity = quantity !== undefined && quantity !== null && `${quantity}`.trim().length > 0;
                    const bundleSpec = (bundleSpecs || []).find(b => b.sku === sku) || {};
                    const ctaText = 'Go to full specs list';
                    const viewPdf = 'View PDF';
                    const { url, pdfUrl } = bundleSpec;
                    return (
                        <div className="bundle-item-card" key={`${sku || name}-${idx}`}>
                            <div className="bundle-item-summary">
                                {hasQuantity && (
                                    <Typography variant="list" className="bundle-item-quantity">
                                        {quantity}x
                                    </Typography>
                                )}
                                {thumbnail && (
                                    <img
                                        className="item-thumbnail bundle-item-thumbnail"
                                        src={thumbnail}
                                        alt={`${name} thumbnail`}
                                    />
                                )}
                                <div className="bundle-item-content">
                                    {hasName && (
                                        <Typography variant="body1" className="bundle-item-title">
                                            {name}
                                        </Typography>
                                    )}
                                </div>
                            </div>
                            {keyPoints && keyPoints.length > 0 && (
                                <List className="bundle-spec-list bundle-item-specs" aria-label="Bundle specifications">
                                    {keyPoints.reduce((items, point, pointIdx) => {
                                        if (typeof point === 'string' && point.length > 0) {
                                            items.push(
                                                <ListItem
                                                    className="bundle-spec-list__item"
                                                    key={`${sku}-point-${pointIdx}`}
                                                >
                                                    {point}
                                                </ListItem>,
                                            );
                                        }

                                        return items;
                                    }, [])}
                                </List>
                            )}
                            <div className="bundle-item-actions">
                                {pdfUrl && (
                                    <Button
                                        theme="accent"
                                        variation="tertiary"
                                        to={pdfUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {viewPdf}
                                    </Button>
                                )}
                                {url && (
                                    <Button
                                        theme="accent"
                                        variation="tertiary"
                                        to={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {ctaText}
                                    </Button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
};

export default HardBundleModal;
